import React from 'react';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import {getFocusedRouteNameFromRoute} from '@react-navigation/native';
import {useTranslation} from 'react-i18next';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {colors} from '../theme';
import OrderNavigator from './OrderNavigator';
import TasksNavigator from './TasksNavigator';
import GalleryNavigator from './GalleryNavigator';

const Tab = createBottomTabNavigator();

const getOrderTabBarVisibility = (route) => {
  const routeName = getFocusedRouteNameFromRoute(route) ?? 'OrderList';
  if (routeName !== 'OrderList') {
    return {display: 'none'};
  }
  return {};
};

const getTasksTabBarVisibility = (route) => {
  const routeName = getFocusedRouteNameFromRoute(route) ?? 'TasksList';
  if (routeName === 'TaskManagement') {
    return {display: 'none'};
  }
  return {};
};

const getGalleryTabBarVisibility = (route) => {
  const routeName = getFocusedRouteNameFromRoute(route) ?? 'GalleryFolderList';
  if (routeName === 'GalleryFolderImages') {
    return {display: 'none'};
  }
  return {};
};

const OrdersTabNavigator = () => {
  const {t} = useTranslation();

  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: colors.primary,
        tabBarInactiveTintColor: colors.textSecondary,
        tabBarHideOnKeyboard: true,
      }}
      safeAreaInsets={{bottom: 0}}>
      <Tab.Screen
        name="OrdersTab"
        component={OrderNavigator}
        options={({route}) => ({
          tabBarLabel: t('nav.orders'),
          tabBarIcon: ({color, size}) => (
            <MaterialCommunityIcons name="clipboard-list" color={color} size={size} />
          ),
          tabBarStyle: getOrderTabBarVisibility(route),
        })}
      />
      <Tab.Screen
        name="TasksTab"
        component={TasksNavigator}
        options={({route}) => ({
          tabBarLabel: t('nav.tasks'),
          tabBarIcon: ({color, size}) => (
            <MaterialCommunityIcons name="clipboard-check-outline" color={color} size={size} />
          ),
          tabBarStyle: getTasksTabBarVisibility(route),
        })}
      />
      <Tab.Screen
        name="GalleryTab"
        component={GalleryNavigator}
        options={({route}) => ({
          tabBarLabel: t('nav.gallery'),
          tabBarIcon: ({color, size}) => (
            <MaterialCommunityIcons name="image-multiple" color={color} size={size} />
          ),
          tabBarStyle: getGalleryTabBarVisibility(route),
        })}
      />
    </Tab.Navigator>
  );
};

export default OrdersTabNavigator;
